export const MoreInfoMessages = {
    description: {
        id: 'Pages.ConsumerNetIncome.View.MoreInfo.description',
    },
    closeButton: {
        id: 'Pages.ConsumerNetIncome.View.MoreInfo.close',
    }
}